import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import { SelectSettings } from '../OfflineDb/IndexDbTranscSP'

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: 'UpdateAlert', payload: Settings })
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: 'UpdateLoader', payload: Isloading })
        },
        UpdateConfiguration: (data, type) => {
            dispatch({ type: type, payload: { data } })
        },
    }
}

class Settings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: false,
        }
    }

    render() {
        return (
            <div>
                <MainLayout />
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle="Settings" isShowAddBtn={false} />
                    <div class="content">
                        {/* <div class="PageHeader_Container">
                            <h2>Settings</h2>
                        </div> */}

                        <div class="card col-md-5">
                            <div class="card-body">
                                <form onSubmit={this.SubmitForm} novalidate>
                                    <div class="Table_Search row border-bottom-0">
                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">
                                                <span style={{ color: 'red' }}>* </span>Operating Start
                                                Time
                                            </label>
                                            <input
                                                autocomplete="off"
                                                type="time"
                                                defaultValue={
                                                    this.props.Config.Setting?.operatingStartTime
                                                }
                                                class="form-control"
                                                id="OperatingStartTime"
                                                required
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">
                                                <span style={{ color: 'red' }}>* </span>Operating End
                                                Time
                                            </label>
                                            <input
                                                autocomplete="off"
                                                type="time"
                                                defaultValue={
                                                    this.props.Config.Setting?.operatingEndTime
                                                }
                                                class="form-control"
                                                id="OperatingEndTime"
                                                required
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">
                                                <span style={{ color: 'red' }}>* </span>Expiration time
                                                for request
                                            </label>
                                            <div
                                                class="col-md-12 col-lg-12"
                                                style={{ padding: '0px', display: 'flex' }}
                                            >
                                                <div style={{ flex: '2' }}>
                                                    <input
                                                        type="number"
                                                        defaultValue={
                                                            this.props.Config.Setting?.requestExpiryTime
                                                        }
                                                        class="form-control"
                                                        id="RequestExpiryTime"
                                                        placeholder="Enter expiration time for request"
                                                        required
                                                    />
                                                </div>
                                                <div style={{ paddingLeft: '10px', flex: '1' }}>
                                                    <select
                                                        defaultValue={
                                                            this.props.Config.Setting?.requestExpiryTimeType
                                                        }
                                                        id="RequestExpiryTimeType"
                                                        class="form-control"
                                                        required
                                                    >
                                                        <option value="minutes">Minute(s)</option>
                                                        <option value="hours">Hour(s)</option>
                                                        <option value="days">Day(s)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">
                                                <span style={{ color: 'red' }}>* </span>Expiration time
                                                for first pickup
                                            </label>
                                            <div
                                                class="col-md-12 col-lg-12"
                                                style={{ padding: '0px', display: 'flex' }}
                                            >
                                                <div style={{ flex: '2' }}>
                                                    <input
                                                        type="number"
                                                        defaultValue={
                                                            this.props.Config.Setting?.firstPickupExpiryTime
                                                        }
                                                        class="form-control"
                                                        id="FirstPickupExpiryTime"
                                                        placeholder="Enter expiration time for first pickup"
                                                        required
                                                    />
                                                </div>
                                                <div style={{ paddingLeft: '10px', flex: '1' }}>
                                                    <select
                                                        defaultValue={
                                                            this.props.Config.Setting
                                                                ?.firstPickupExpiryTimeType
                                                        }
                                                        id="FirstPickupExpiryTimeType"
                                                        class="form-control"
                                                        required
                                                    >
                                                        <option value="minutes">Minute(s)</option>
                                                        <option value="hours">Hour(s)</option>
                                                        <option value="days">Day(s)</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">
                                                <span style={{ color: 'red' }}>* </span>No of
                                                re-attempts allowed
                                            </label>
                                            <input
                                                autocomplete="off"
                                                type="number"
                                                defaultValue={
                                                    this.props.Config.Setting?.allowedReAttempts
                                                }
                                                class="form-control"
                                                placeholder="Enter re-attempts allowed"
                                                id="AllowedReAttempts"
                                                required
                                            />
                                        </div>

                                        <div class="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label for="">
                                                <span style={{ color: 'red' }}>* </span>Incentive/KM
                                            </label>
                                            <input
                                                autocomplete="off"
                                                type="number"
                                                defaultValue={this.props.Config.Setting?.incentive}
                                                class="form-control"
                                                placeholder="Enter rupees"
                                                id="Incentive"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>Hcf Incentive per Sample
                                            </label>
                                            <input
                                                autoComplete="off"
                                                type="number"
                                                defaultValue={
                                                    this.props.Config.Setting?.hcfIncentivePerSample
                                                }
                                                className="form-control"
                                                placeholder="Hcf Incentive Per Sample"
                                                id="hcfIncentivePerSample"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>Incentive per
                                                Sample
                                            </label>
                                            <input
                                                autoComplete="off"
                                                type="number"
                                                defaultValue={
                                                    this.props.Config.Setting?.incentivePerSample
                                                }
                                                className="form-control"
                                                placeholder="Incentive Per Sample"
                                                id="IncentivePerSample"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>WHT %
                                            </label>
                                            <input
                                                autoComplete="off"
                                                type="number"
                                                defaultValue={
                                                    this.props.Config.Setting?.whtPercentage
                                                }
                                                className="form-control"
                                                placeholder="Wht %"
                                                id="WhtPercentage"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>GST %
                                            </label>
                                            <input
                                                autoComplete="off"
                                                type="number"
                                                defaultValue={
                                                    this.props.Config.Setting?.gstPercentage
                                                }
                                                className="form-control"
                                                placeholder="Gst %"
                                                id="GstPercentage"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="">
                                                <span style={{ color: 'red' }}>* </span>FR Incentive
                                            </label>
                                            <input
                                                autoComplete="off"
                                                type="number"
                                                defaultValue={
                                                    this.props.Config.Setting?.fixedRiderIncentive
                                                }
                                                className="form-control"
                                                placeholder="FR Incentive"
                                                id="FixedRiderIncentive"
                                                required
                                            />
                                        </div>

                                        <div className="formInput_Container col-md-6 mt-2 ml-3">
                                            <div className="text-center ">
                                                <label className="CheckBox_container ">
                                                    <span>System Status</span>
                                                    <input
                                                        type="checkbox"
                                                        onChange={(event) =>
                                                            this.setState({ status: event.target.checked })
                                                        }
                                                        checked={this.state.status}
                                                    />
                                                    <span className="CheckBox_checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                        <div class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <button
                                                type="submit"
                                                id="Form_SaveBtn"
                                                class="btn btn_style1"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === '') {
            this.props.history.push('/Login')
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink('MenuLink_Settings')
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'GET',
            false,
            Common.BaseUrlAPI + '/api/Settings/Select',
            {},
            (resp) => {
                if (resp.status) {
                    const { data } = resp
                    $('#OperatingStartTime').val(data.operatingStartTime)
                    $('#OperatingEndTime').val(data.operatingEndTime)
                    $('#RequestExpiryTime').val(data.requestExpiryTime)
                    $('#RequestExpiryTimeType').val(data.requestExpiryTimeType)
                    $('#FirstPickupExpiryTime').val(data.firstPickupExpiryTime)
                    $('#FirstPickupExpiryTimeType').val(data.firstPickupExpiryTimeType)
                    $('#AllowedReAttempts').val(data.allowedReAttempts)
                    $('#Incentive').val(data.incentive)
                    $('#IncentivePerSample').val(data.incentivePerSample)
                    $('#hcfIncentivePerSample').val(data.hcfIncentivePerSample)
                    $('#WhtPercentage').val(data.whtPercentage)
                    $('#GstPercentage').val(data.gstPercentage)
                    $('#FixedRiderIncentive').val(data.fixedRiderIncentive)
                    this.setState({
                        status: data.systemStatus,
                    })
                }
            },
        )
    }

    SubmitForm = (e) => {
        e.preventDefault()
        this.props.ShowLoader({ Isloading: true })
        var Parameters = {
            operatingStartTime: $('#OperatingStartTime').val(),
            operatingEndTime: $('#OperatingEndTime').val(),
            requestExpiryTime: $('#RequestExpiryTime').val(),
            requestExpiryTimeType: $('#RequestExpiryTimeType').val(),
            firstPickupExpiryTime: $('#FirstPickupExpiryTime').val(),
            firstPickupExpiryTimeType: $('#FirstPickupExpiryTimeType').val(),
            allowedReAttempts: $('#AllowedReAttempts').val(),
            incentive: $('#Incentive').val(),
            incentivePerSample: $('#IncentivePerSample').val(),
            hcfIncentivePerSample: $('#hcfIncentivePerSample').val(),
            whtPercentage: $('#WhtPercentage').val(),
            gstPercentage: $('#GstPercentage').val(),
            fixedRiderIncentive: $('#FixedRiderIncentive').val(),
            systemStatus: this.state.status,
        }
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            'Post',
            false,
            Common.APILinks.Save_Settings,
            JSON.stringify(Parameters),
            (resp) => {
                if (resp.status) {
                    SyncConfig(
                        () => {
                            SelectSettings(
                                (data) => {
                                    this.props.UpdateConfiguration(data, 'UpdateSystemSetting')
                                },
                                (error) => { },
                            )
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({ Type: 1, Msg: 'Saved successfully' })
                            setTimeout(() => {
                                $('#Alertmsgbtn').click()
                            }, 50)
                        },
                        () => {
                            this.props.ShowLoader({ Isloading: false })
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: 'Error in sync, please reload the page',
                            })
                            setTimeout(function () {
                                $('#Alertmsgbtn').click()
                            }, 50)
                        },
                    )
                } else {
                    this.props.ShowLoader({ Isloading: false })
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(() => {
                        $('#Alertmsgbtn').click()
                    }, 50)
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                    Type: 0,
                    Msg: 'Something went wronge, please try again.',
                })
                setTimeout(() => {
                    $('#Alertmsgbtn').click()
                }, 50)
            },
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
